import { render, staticRenderFns } from "./TypesTable.vue?vue&type=template&id=2842657f&"
import script from "./TypesTable.vue?vue&type=script&lang=js&"
export * from "./TypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports